import { useContext, useState } from "react";
import { Box, IconButton, Stack, Paper, Typography } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MenuIcon from "@mui/icons-material/Menu";
import Logout from "@mui/icons-material/Logout";
import AiChatHelp from '../../../right-panel/help/aiChat'
import { AuthContext } from '../../../../contexts/auth/authContext'
import { DataDispatchContext } from '../../../../contexts/data/dataContext'
import { 
    profileIconPath,
    chatIcon
  } from '../../../common/iconPaths'
import custom from '../../../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain } from '../../../../services/constants'
import { sendClickAnalytics } from '../../../common/util/util'

type Props = {
    selected: String 
    itemList: any[]
    handleClick: Function
}

export default function MobileContextMenu({
    selected, 
    itemList,
    handleClick
}: Props) {
    const [drawer, setDrawerState] = useState(false);
    const dispatch: any = useContext(DataDispatchContext)
    const auth = useContext(AuthContext)
    const colorSelected = 'primary.main'

    function signOutClicked() {
        sendClickAnalytics('/profile', {
              domain: analyticsDomain.profile,
              name: analyticsCta.signOut,
              metadata: {},
            })
        auth.signOut()
    }

    function handleChat() {
        dispatch({
            type: 'setRightPanel',
            rightPanel: <AiChatHelp key="help"/>
        })
    }
   
    const toggleDrawer = (open: any) => (event: any) => {
        if (event.type === 'keydown' && 
            (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setDrawerState(open);
      };

    const menuItemList = [...itemList,
        {
            id: 'profile',
            name: 'Profile',
            iconPath: profileIconPath,
            action: handleClick
        },
        {
            id: 'help',
            name: "Help",
            iconPath: chatIcon,
            action: handleChat
        },                        
        {
            id: 'signout',
            name: "Sign Out",
            iconPath: (<Logout />),
            action: signOutClicked
        }
    ]
    const menuItems = (items: any[]) => (
        <>
          {items.map(item=>(
            <Box sx={{ 
                      width: '100%', 
                      cursor: 'pointer'
                    }}
                    id={`${item.id}Mobile`} 
                    key={item.id} 
                    height={custom.sizes.xl}
                    onClick={(event: any)=>{
                        setDrawerState(false);
                        item.action(event)
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    alignContent={"center"}
                    >
                <Stack alignItems="start" direction="row" 
                    justifyContent="flex-center" 
                    pr={custom.spacing.xxs}>
                    <Typography
                        variant="szHeading.Regular.xSmall" 
                        sx={{ 
                        color: `${item.id===selected?
                            colorSelected:item.id!=='signout'?
                            'inherit':'error.main'}`  }}>
                            {item.name}
                    </Typography>

                    {item.id!=='signout'?
                    <ArrowForwardIosIcon sx={{ 
                        ml: 'auto', 
                        pr: custom.spacing.sm, 
                        height: '20px', 
                        width: '20px', 
                        color: `${item.id===selected?colorSelected:'inherit'}` 
                    }}/>:<></>}
                </Stack>
            </Box>
          ))}
        </>
      )

    return (
        <>
        <Box ml={custom.spacing.md} 
            height={{
                xs: custom.sizes.hf,
                sm: custom.sizes.hf,
                md: 0,
                lg: 0
            }}>
            <IconButton 
                edge="start" 
                color="inherit" 
                aria-label="open drawer" 
                onClick={toggleDrawer(!drawer)}
                sx={{
                    pt: custom.spacing.sm,
                    display: {
                        xs: 'flex',
                        sm: 'flex',
                        md: 'none',
                        lg: 'none',
                    }
                }}
                >
                {drawer ?
                    <Box
                        id="closeContextMenu"
                        sx={{ 
                            mt: '10px',
                            ml: '10px',
                            cursor: 'pointer',
                            height: '24px',
                            width: '24px'
                        }}
                        component="img"
                        src="/images/X.svg" 
                    />
                :
                    <MenuIcon sx={{ 
                        height: '24px',
                        width: '24px',
                        p: '10px'
                    }} />
                }
            </IconButton>
        </Box>
        <Paper elevation={0}
            sx={{
                width: "100%",
                pl:custom.spacing.sm,
                pr:custom.spacing.xxs,
                pt:custom.spacing.sm, 
                display: drawer?'block':'none',
                position: 'fixed',
                top: 73,
                left: 0,
                boxShadow: 5
            }}>
            {menuItems(menuItemList)}
        </Paper>
    </>
    )
}